export default __webpack_public_path__ + "static/media/leela-palace.439094ed.svg";